const EventTypes = {
    OPEN_SIDEBAR: 'OPEN_SIDEBAR',
    CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
    RESIZE_WINDOW: 'RESIZE_WINDOW',
    UPDATE_UNIT_SYSTEM: 'UPDATE_UNIT_SYSTEM',
    UPDATE_ELEMENT_SHAPE: 'UPDATE_ELEMENT_SHAPE',
    UPDATE_ELEMENT_LABELS: 'UPDATE_ELEMENT_LABELS',
    UPDATE_ELEMENT_LAYER: 'UPDATE_ELEMENT_LAYER',
    UPDATE_ELEMENT_DATE: 'UPDATE_ELEMENT_DATE',
    DATE_VALIDATION_ERROR: 'DATE_VALIDATION_ERROR',
    UPDATE_LAYER_NAME: 'UPDATE_LAYER_NAME',
    ADD_LAYER: 'ADD_LAYER',
    REMOVE_LAYER: 'REMOVE_LAYER',
    FOCUS_INPUT: 'FOCUS_INPUT',
    BLUR_INPUT: 'BLUR_INPUT',
    DATA_LOADED: 'DATA_LOADED',
    TIMELINE_DATE_CHANGED: 'TIMELINE_DATE_CHANGED',
    TIMELINE_TOGGLED: 'TIMELINE_TOGGLED',
}

export default EventTypes;
